var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticStyle: { width: "100%", height: "300px" },
    attrs: { id: "pubStatisticChart" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }